module.exports = __webpack_public_path__ + "static/pigly01-sq-6cdd2ebe08d51aa4a78638b91ea82a9d.png";